export default __webpack_public_path__ + "static/media/welcome-image-crop.6a478a24.png";